

export interface CoreSchoolSoftConfiguration {
    id: string
    type: SchoolSoftImportType
    webApp?: string
    municipalityCode?: string
    targetSystem: SchoolSoftTargetSystem
    sensitiveFields: SchoolSoftSensitiveFields
    activityNaming: SchoolSoftActivityNaming
}

export enum SchoolSoftImportType {
    Unknown = 0,
    Full = 1,
    Selected = 2,
    Hybrid = 3,
    HybridSS12000Activities = 4
}; 

export enum SchoolSoftTargetSystem {
    Unknown = 0,
    Classroom = 1,
    Teams = 2,
}

export enum SchoolSoftActivityNaming {
    Undefined = 0,

    /// <summary>
    /// Take the activity name from SS12000 Activity DisplayName
    /// </summary>
    ActivityName = 1,

    /// <summary>
    /// Take the activity name from SS12000 Group DisplayName
    /// </summary>
    GroupName = 2,

    /// <summary>
    /// Take the activity name from SS12000 Group DisplayName + Activity DisplayName
    /// </summary>
    GroupWithActivityName = 3,
}

export enum SchoolSoftSensitiveFields {
    None = 0x0000,
    Address = 0x0001,
    CivicNo = 0x0002,
    PersonalEmail = 0x0004,
    Custodians = 0x0008,
    BirthDate = 0x0010,
    PhoneNumber = 0x0020,
    Sex = 0x0040,
}
